import { useEffect, useState } from 'react';
import { primitives } from '@veneer/primitives';
import { TableDesktop } from './table-dekstop';
import { TableMobile } from './table-mobile';
import { ColumnData, TableData } from '../types';
import { ThemeProvider } from 'styled-components';

export interface TableProps {
  data: TableData[];
  columns: ColumnData[];
  type: 'cancellation' | 'standard';
}

export const Table = ({ data, columns, type }: TableProps) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const mobileBreakpoint = primitives.layout.breakpoint0;
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <ThemeProvider theme={{ tableType: type }}>
      {windowWidth > mobileBreakpoint ? (
        <TableDesktop data={data} columns={columns} />
      ) : (
        <TableMobile data={data} columns={columns} />
      )}
    </ThemeProvider>
  );
};
